/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SupplierPimImportationsQueryVariables = Types.Exact<{
  supplierId: Types.Scalars['ID']['input'];
}>;


export type SupplierPimImportationsQuery = { pimSupplier: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'PimSupplierResult', supplier: { __typename: 'PimSupplier', id: string, itekCompanyIdentifier?: string | null } }, pimImportations: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'PimImportationsResult', importations: Array<{ __typename: 'PimImportation', id: string, url: string, status: Types.PimImportationStatus, createdAt: any, filename: string, searchIndexCompletionPercentage: number, importCompletionPercentage: number, completionPercentage: number, totalProcessedProducts?: number | null, deletedAt?: any | null, isProcessing: boolean }> } };

export type SupplierPimImportationRowFragment = { __typename: 'PimImportation', id: string, url: string, status: Types.PimImportationStatus, createdAt: any, filename: string, searchIndexCompletionPercentage: number, importCompletionPercentage: number, completionPercentage: number, totalProcessedProducts?: number | null, deletedAt?: any | null, isProcessing: boolean };

export const SupplierPimImportationRowFragmentDoc = gql`
    fragment SupplierPimImportationRow on PimImportation {
  id
  url
  status
  createdAt
  filename
  searchIndexCompletionPercentage
  importCompletionPercentage
  completionPercentage
  totalProcessedProducts
  deletedAt
  isProcessing
}
    `;
export const SupplierPimImportationsDocument = gql`
    query SupplierPimImportations($supplierId: ID!) {
  pimSupplier(id: $supplierId) {
    ... on PimSupplierResult {
      supplier {
        id
        itekCompanyIdentifier
      }
    }
  }
  pimImportations(filters: {supplierId: $supplierId}) {
    ... on PimImportationsResult {
      importations {
        id
        ...SupplierPimImportationRow
      }
    }
  }
}
    ${SupplierPimImportationRowFragmentDoc}`;

/**
 * __useSupplierPimImportationsQuery__
 *
 * To run a query within a React component, call `useSupplierPimImportationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierPimImportationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierPimImportationsQuery({
 *   variables: {
 *      supplierId: // value for 'supplierId'
 *   },
 * });
 */
export function useSupplierPimImportationsQuery(baseOptions: Apollo.QueryHookOptions<SupplierPimImportationsQuery, SupplierPimImportationsQueryVariables> & ({ variables: SupplierPimImportationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupplierPimImportationsQuery, SupplierPimImportationsQueryVariables>(SupplierPimImportationsDocument, options);
      }
export function useSupplierPimImportationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupplierPimImportationsQuery, SupplierPimImportationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupplierPimImportationsQuery, SupplierPimImportationsQueryVariables>(SupplierPimImportationsDocument, options);
        }
export function useSupplierPimImportationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupplierPimImportationsQuery, SupplierPimImportationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SupplierPimImportationsQuery, SupplierPimImportationsQueryVariables>(SupplierPimImportationsDocument, options);
        }
export type SupplierPimImportationsQueryHookResult = ReturnType<typeof useSupplierPimImportationsQuery>;
export type SupplierPimImportationsLazyQueryHookResult = ReturnType<typeof useSupplierPimImportationsLazyQuery>;
export type SupplierPimImportationsSuspenseQueryHookResult = ReturnType<typeof useSupplierPimImportationsSuspenseQuery>;
export type SupplierPimImportationsQueryResult = Apollo.QueryResult<SupplierPimImportationsQuery, SupplierPimImportationsQueryVariables>;